import { ForgotPasswordModalComponent } from '$core/modal/forgot-password-modal/forgot-password-modal.component';
import { LoginModalComponent } from '$core/modal/login-modal/login-modal.component';
import { RegistrationModalComponent } from '$core/modal/registration-modal/registration-modal.component';
import { AuthModalComponent } from '$core/models/auth-modal-component';
import {
  AuthParamsValues,
  AUTH_TYPE_KEY,
  USER_TYPE_KEY,
} from '$core/models/auth-modals-query-params';
import { UserTypes } from '$core/models/user';
import { AuthModalsService } from '$core/services/auth-modals.service';
import { AuthenticationService } from '$core/services/auth.service';
import { EyeSightService } from '$core/services/eye-sight.service';
import { LanguageService } from '$core/services/language.service';
import { SessionService } from '$core/services/session.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { faChevronDown, faGlasses } from '@fortawesome/free-solid-svg-icons';
import { take } from 'rxjs/operators';
import { isAuthParamsAreRight } from './auth-modal-params.helpers';
import { NotificationsDataService } from '$modules/personal/notifications/notifications-data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header-user',
  templateUrl: './header-user.component.html',
  styleUrls: ['./header-user.component.scss'],
})
export class HeaderUserComponent implements OnInit, OnDestroy {
  public readonly faChevronDown = faChevronDown;
  public readonly faGlasses = faGlasses;
  public notificationsCounter$: Observable<number>;

  public get session() {
    return this.sessionService.session;
  }

  public get isIndividual(): boolean {
    return this.session && this.session.type === UserTypes.Individual;
  }

  constructor(
    private languageService: LanguageService,
    private sessionService: SessionService,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private authModalsService: AuthModalsService,
    public eyeService: EyeSightService,
    private notificationsDataService: NotificationsDataService
  ) {}

  public ngOnInit(): void {
    this.subscribeToIsAuthorized();
  }

  public ngOnDestroy(): void {}

  private openAuthModalByQueryParams(): void {
    this.activatedRoute.queryParams
      .pipe(take(1))
      .subscribe((params: Params) => {
        const userType = params[USER_TYPE_KEY];
        const authParam = params[AUTH_TYPE_KEY];
        const isParamsAreRight = isAuthParamsAreRight(userType, authParam);

        if (isParamsAreRight) {
          let modalComponent: AuthModalComponent;

          switch (authParam) {
            case AuthParamsValues.SIGNIN:
              modalComponent = LoginModalComponent;
              break;
            case AuthParamsValues.REGISTRATION:
              modalComponent = RegistrationModalComponent;
              break;
            case AuthParamsValues.FORGOT_PASSWORD:
              modalComponent = ForgotPasswordModalComponent;
              break;

            default:
              modalComponent = LoginModalComponent;
              break;
          }

          this.authModalsService.show(modalComponent, userType, authParam);
        } else {
          this.authModalsService.clearQueryParam();
        }
      });
  }

  private subscribeToIsAuthorized(): void {
    this.authService.isAuthorized$.pipe(take(1)).subscribe((isAuthorized) => {
      if (!isAuthorized) {
        this.openAuthModalByQueryParams();
      } else {
        this.authModalsService.clearQueryParam();
        this.notificationsDataService.refresh$.next();
        this.notificationsCounter$ =
          this.notificationsDataService.notificationsCounter$;
      }
    });
  }

  public onOpenLogin(): void {
    this.authModalsService.show(
      LoginModalComponent,
      UserTypes.Individual,
      AuthParamsValues.SIGNIN
    );
  }

  public logout(): void {
    this.authService.logout(true);
  }
}
